<template>
  <div class="embody">
    <van-sticky>
      <div
        class="embodyNav"
        :style="{ 'padding-top': (isiOSX ? 44 : 24) + 'px' }"
      >
        <img
          class="navLeft"
          @click="goBack()"
          src="./../../../assets/decoration/back.png"
        />
        <span class="navTitle">提现</span>
        <span class="navRight" @click="toEarnings()">收益明细</span>
      </div>
    </van-sticky>
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <div class="content">
        <div class="top">
          <div class="tip">
            <img src="./../../../assets/decoration/tip.png" alt="" />
            <p>
              每月提现{{
                data.withdrawal_count
                  ? data.withdrawal_count.system_withdrawal_count
                  : "0"
              }}次，提现金额不小于1元。
            </p>
          </div>
          <div class="topContent">
            <span>可提现金额</span>
            <h3>{{ data.balance }}</h3>
            <p>累计已提现{{ data.withdrawn }}</p>
            <button
              v-if="
                data.withdrawal_count &&
                data.withdrawal_count.use_withdrawal_count <
                  data.withdrawal_count.system_withdrawal_count
              "
              @click="toEmbody()"
            >
              去提现
            </button>
            <button class="forbidden" v-else>本月提现机会已用完</button>
          </div>
        </div>
        <!-- 体现明细 -->
        <div class="embodyList">
          <van-sticky :offset-top="isiOSX ? 88 : 68">
            <div class="embodyList_top">
              <h3>提现明细</h3>
              <span @click="dataStatusPickerShow = true"
                >{{ dataStatusText }}
                <img src="./../../../assets/decoration/bottom.png" alt="" />
              </span>
            </div>
          </van-sticky>
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <template #finished>
              <div class="finishedTip">
                <div v-if="dataList.length == 0">
                  <img src="./../../../assets/decoration/noData.png" alt="" />
                  <p>暂无相关数据</p>
                </div>
                <div v-else>没有更多了</div>
              </div>
            </template>
            <div class="embodyList_content">
              <div
                class="item"
                v-for="(item, index) in dataList"
                :key="index"
                @click="toEmbodyDetails(item.id)"
              >
                <div>
                  <span>{{ item.created_at }}</span>
                  <span v-if="item.status == 1">审核中</span>
                  <span v-if="item.status == 2">已完成</span>
                  <span v-if="item.status == -1">已驳回</span>
                </div>
                <div class="bomDiv">
                  <p>提现</p>
                  <p class="money">{{ item.money }}</p>
                </div>
              </div>
            </div>
          </van-list>
        </div>
      </div>
    </van-pull-refresh>
    <van-action-sheet v-model="dataStatusPickerShow" title="选择提现明细类型">
      <div class="sheetContent">
        <p
          v-for="(item, index) in actions"
          :class="{ check: item.checkd }"
          :key="index"
          @click="onSelect(index)"
        >
          {{ item.name }}
        </p>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      type: 1, //1代理人，2合伙人
      city_agent_id: null,
      dataStatusText: "全部",
      status: 0,
      dataStatusPickerShow: false,
      actions: [
        { name: "全部", value: 0, checkd: true },
        { name: "审核中", value: 1, checkd: false },
        { name: "已驳回", value: -1, checkd: false },
        { name: "已完成", value: 2, checkd: false },
      ],
      data: {},
      money: 0,
      isWithdrawal: false,
      page: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      refreshing: false,
      dataList: [],
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(JSON.parse(sessionStorage.getItem("token")));
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.city_agent_id) {
      this.city_agent_id = this.$route.query.city_agent_id;
    }
    this.initData();
    this.getData();
  },
  mounted() {},
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    // 获取数据信息
    initData() {
      if (this.type == 1) {
        // 代理人
        this.$api
          .get("decoration/member/withdrawal/city/agent/is/withdrawal", {
            city_agent_id: this.city_agent_id,
          })
          .then((res) => {
            this.data = res;
          });
      } else {
        // 合伙人
        this.$api
          .get("decoration/member/withdrawal/city/partner/is/withdrawal", {
            city_partner_area_id: this.city_agent_id,
          })
          .then((res) => {
            this.data = res;
          });
      }
    },
    toEmbody() {
      if (this.data.status == -3) {
        this.$toast("需先解除拉黑才可进行去提现操作。");
      } else if (this.data.balance < 1) {
        this.$toast("可提现金额小于1元，不可进行提现操作。");
      } else {
        this.$router.push({
          path: "/decoration/embody/applyForEmbody",
          query: {
            type: this.type,
            city_agent_id: this.city_agent_id,
          },
        });
      }
    },
    getData() {
      this.loading = true;
      if (this.type == 1) {
        this.$api
          .get("decoration/member/withdrawal/city/agent/list", {
            pageSize: this.pageSize,
            page: this.page,
            city_agent_id: Number(this.city_agent_id),
            status: this.status,
          })
          .then((res) => {
            // this.dataList = res.list;
            this.dataList = this.dataList.concat(res.list);
            this.loaded = true;
            this.refreshing = false;
            this.loading = false;
            if (this.dataList.length >= res.total) {
              // 数据全部加载完成
              this.finished = true;
            } else {
              this.finished = false;
            }
          })
          .catch((err) => {
            this.refreshing = false;
            this.loading = false;
            this.finished = true;
          });
      } else {
        this.$api
          .get("decoration/member/withdrawal/city/partner/list", {
            pageSize: this.pageSize,
            page: this.page,
            city_partner_area_id: Number(this.city_agent_id),
            status: this.status,
          })
          .then((res) => {
            // this.dataList = res.list;
            this.dataList = this.dataList.concat(res.list);
            this.loaded = true;
            this.refreshing = false;
            this.loading = false;
            if (this.dataList.length >= res.total) {
              // 数据全部加载完成
              this.finished = true;
            } else {
              this.finished = false;
            }
          })
          .catch((err) => {
            this.refreshing = false;
            this.loading = false;
            this.finished = true;
          });
      }
    },
    // 下拉刷新
    onRefresh() {
      this.page = 1;
      this.dataList = [];
      this.getData();
      this.initData();
    },
    // 上拉加载
    onLoad() {
      this.page++;
      this.getData();
    },
    onSelect(index) {
      this.actions.forEach((item) => {
        item.checkd = false;
      });
      this.actions[index].checkd = true;
      this.dataStatusText = this.actions[index].name;
      this.status = this.actions[index].value;
      this.dataStatusPickerShow = false;
      this.onRefresh();
    },
    toEmbodyDetails(id) {
      this.$router.push({
        path: "/decoration/embody/embodyDetails",
        query: {
          id: id,
          type: this.type,
        },
      });
    },
    // 收益明细
    toEarnings() {
      this.$router.push({
        path: "/decoration/embody/earningsList",
        query: {
          city_agent_id: this.city_agent_id,
          type: this.type,
        },
      });
    },
  },
};
</script>
<style lang="less">
.embody {
  min-height: 100%;
  background: #f5f6ff;
  .embodyNav {
    background: #ffffff;
    height: 44px;
    position: relative;
    .navLeft {
      width: 24px;
      height: 24px;
      position: absolute;
      left: 16px;
      bottom: 10px;
    }
    .navTitle {
      position: absolute;
      left: 50%;
      bottom: 10px;
      transform: translateX(-50%);
      font-size: 17px;
      font-weight: 700;
      color: #404247;
    }
    .navRight {
      position: absolute;
      right: 16px;
      bottom: 10px;
      font-size: 14px;
      color: #404247;
    }
  }
  .content {
    .top {
      background-color: #ffffff;
      border-radius: 0px 0px 16px 16px;
      .tip {
        background: #faf6f1;
        border-radius: 4px;
        margin: 0 16px;
        display: flex;
        padding: 6px 12px 6px 6px;
        img {
          width: 12px;
          height: 12px;
          flex-shrink: 0;
          margin: 2px 2px 0 0;
        }
        p {
          font-size: 12px;
          font-weight: 600;
          color: #c38e58;
          line-height: 17px;
        }
      }
      .topContent {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 24px 16px 40px;
        span {
          font-size: 12px;
          color: #999999;
          line-height: 17px;
        }
        h3 {
          font-size: 32px;
          font-weight: 600;
          color: #333333;
          line-height: 45px;
          margin: 12px 0;
        }
        p {
          font-size: 12px;
          color: #333333;
          line-height: 17px;
        }
        button {
          width: 217px;
          // height: 46px;
          line-height: 46px;
          background: #5853e9;
          border-radius: 25px;
          font-size: 16px;
          font-weight: 500;
          color: #ffffff;
          margin-top: 24px;
          border: none;
        }
        .forbidden {
          background: rgba(88, 83, 233, 0.2);
        }
      }
    }
    .embodyList {
      margin-top: 13px;
      .embodyList_top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 24px;
        background: #f5f6ff;
        h3 {
          margin: 0;
          font-size: 15px;
          color: #333333;
          line-height: 21px;
        }
        span {
          background: #ffffff;
          border-radius: 13px;
          font-size: 13px;
          color: #666666;
          line-height: 18px;
          padding: 4px 6px 4px 16px;
          display: flex;
          align-items: center;

          img {
            width: 12px;
            height: 12px;
            margin-left: 6px;
          }
        }
      }
      .embodyList_content {
        margin: 0 16px;
        .item {
          padding: 18px 16px;
          background: #ffffff;
          border-radius: 8px;
          margin-top: 12px;
          div {
            display: flex;
            justify-content: space-between;
            align-items: center;
            span {
              font-size: 13px;
              color: #999999;
              line-height: 18px;
            }
            p {
              font-size: 14px;
              color: #333333;
              line-height: 20px;
            }
            .money {
              font-size: 16px;
              font-weight: bold;
            }
          }
        }
        .bomDiv {
          margin-top: 6px;
        }
      }
    }
  }
  .finishedTip {
    img {
      width: 149px;
      height: 125px;
      margin-top: 64px;
    }
  }
  .sheetContent {
    margin: 12px 0 55px;
    p {
      font-size: 16px;
      color: #333333;
      line-height: 22px;
      padding: 12px 0;
      text-align: center;
    }
    .check {
      color: #5853e9;
    }
  }
  .van-action-sheet__header {
    color: #999999;
  }
}
</style>